import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Store } from "@ngrx/store";
import { filter, map, Observable } from "rxjs";
import * as fromApp from "../store/app.reducer";

@Injectable({
  providedIn: "root",
})
export class OnlyDineInGuard implements CanActivate {
  constructor(private router: Router, private store: Store<fromApp.AppState>) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.store.select("auth").pipe(
      map((auth) => {
        return auth;
      }),
      filter((auth) => {
        if (
          auth.loginState !== "login_loading" &&
          (auth.loginState !== "login_completed" || auth.user !== null)
        ) {
          return true;
        }
      }),
      map((auth) => {
        if (
          (auth && !auth.user) ||
          (!auth.user.only_dinein && !auth.user.only_visitor)
        ) {
          return true;
        }
        return this.router.createUrlTree(["/catalog"]);
      })
    );
  }
}
